import React from 'react'
import styled, { css } from 'styled-components'
import { useTranslation } from 'next-i18next'
import { getAnniversarySvgUrl } from 'components/PromotedFlight/anniversaryAssets'

const Logo = styled.span<{ $isRTL?: boolean }>`
  position: absolute;
  top: -28px;
  width: 73px;
  height: 55px;
  pointer-events: none;
  z-index: 2;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  ${({ $isRTL }) =>
    $isRTL
      ? css`
          right: 100%;
          left: auto;
          margin-right: 12px;
          margin-left: 0;
        `
      : css`
          left: 100%;
          right: auto;
          margin-left: 12px;
          margin-right: 0;
        `}

  img {
    width: 73px;
    height: 55px;
    display: block;
  }
`

type Wingie10YearsLogoProps = {
  isRTL?: boolean
}

const Wingie10YearsLogo: React.FC<Wingie10YearsLogoProps> = ({ isRTL = false }) => {
  const { i18n } = useTranslation()
  const src = getAnniversarySvgUrl('white', i18n?.language)

  return (
    <Logo $isRTL={isRTL} data-testid="wingie-10-years-logo" aria-hidden="true">
      <img src={src} alt="" width={73} height={55} decoding="async" />
    </Logo>
  )
}

export default Wingie10YearsLogo
